import styled from "styled-components";
import { Link, NavLink as RouterNavLink } from "react-router-dom";
import { theme } from "../../styles/styles";

export const MainLayout = styled("div")`
  background: ${theme.bg};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Navbar = styled("header")`
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(11, 13, 18, 0.85);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid ${theme.border};
`;

export const NavbarInner = styled("div")`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  @media only screen and (max-width: 1024px) {
    padding: 0 30px;
  }

  @media only screen and (max-width: 768px) {
    padding: 0 18px;
  }

  @media only screen and (max-width: 560px) {
    height: auto;
    padding: 12px 18px;
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const Brand = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: "Motiva Sans Bold", sans-serif;
  font-size: 20px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${theme.heading};

  &:hover {
    color: ${theme.heading};
  }

  img {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    box-shadow: 0 0 0 1px ${theme.border};
  }
`;

export const NavLinks = styled("nav")`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const MainContent = styled("main")`
  flex: 1;
  padding: 3rem 0 5rem;
`;

export const Title = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: ${theme.heading};

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled(RouterNavLink)`
  font-size: 15px;
  color: ${theme.textMuted};
  padding: 0.45rem 0.9rem;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${theme.heading};
    background: ${theme.surfaceAlt};
  }

  &.active {
    color: ${theme.heading};
    background: ${theme.surfaceAlt};
    box-shadow: inset 0 -2px 0 ${theme.accent};
  }
`;
